import { getCompanyById } from '@/services/ws-companies/src/main/resources/rest-api';
import { createContexts } from '@/js/libs/create-contexts';
import { useIdentityUser } from '@/js/libs/use-auth';
import { NotActive, useMappedRequest, useRequest } from '@/js/libs/use-request';

export const { useNumberFormatContext } = createContexts({
  NumberFormat() {
    const currentUser = useIdentityUser();
    const companyId = currentUser?.company?.id;

    const companyRequest = useRequest({
      apiMethod: getCompanyById,
      params: companyId ? { id: companyId } : NotActive,
    });
    const countryRequest = useMappedRequest(companyRequest, (data) => data.countryCode);

    return { countryRequest };
  },
});

export const NumbersFormatContextProvider = useNumberFormatContext.Provider;
